<template>
  <transition name="tp-bubble">
    <div v-if="visible" class="tp-bubble" @click.stop>
      <div class="tp-bubble__head">
        <span class="tp-bubble__dot"></span>
        AI suggestion
      </div>
      <span v-if="!loading" class="tp-bubble__text" v-html="html"></span>
      <div v-else class="tp-bubble__loader">
        <span class="tp-bubble__dot-anim"></span>
        <span class="tp-bubble__dot-anim"></span>
        <span class="tp-bubble__dot-anim"></span>
      </div>
      <div v-if="html" class="tp-bubble__actions">
        <button type="button" class="tp-bubble__btn" @click="$emit('dislike')" aria-label="Not helpful">
          <font-awesome-icon icon="fa-solid fa-thumbs-down" />
        </button>
        <button type="button" class="tp-bubble__btn tp-bubble__btn--accent" @click="$emit('like')" aria-label="Use this suggestion">
          <font-awesome-icon icon="fa-solid fa-thumbs-up" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AiSuggestionBubble',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    html: { type: String, default: '' },
  },
  emits: ['like', 'dislike'],
});
</script>

<style scoped>
.tp-bubble {
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  width: 280px;
  max-width: 80vw;
  padding: 14px 16px;
  border-radius: var(--tm-radius-md, 16px);
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  box-shadow: var(--tm-shadow-lg);
  color: var(--tm-ink, var(--dark));
  text-align: left;
  z-index: 1000;
}

.tp-bubble__head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--tm-ink-faint, rgba(47, 74, 96, 0.55));
  margin-bottom: 8px;
}

.tp-bubble__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--tm-accent-bright, var(--blue));
}

.tp-bubble__text {
  font-size: 0.85rem;
  line-height: 1.5;
}

.tp-bubble__text :deep(.result-option) {
  color: var(--tm-accent-bright, var(--blue_plus));
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px solid var(--tm-border-focus, rgba(28, 61, 110, 0.35));
}

.tp-bubble__loader {
  display: flex;
  gap: 6px;
  padding: 4px 0;
}

.tp-bubble__dot-anim {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--tm-accent-bright, var(--blue));
  animation: tp-bubble-bounce 0.6s ease-in-out infinite alternate;
}

.tp-bubble__dot-anim:nth-child(2) {
  animation-delay: 0.15s;
}

.tp-bubble__dot-anim:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes tp-bubble-bounce {
  100% {
    transform: translateY(-4px);
    opacity: 0.5;
  }
}

.tp-bubble__actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 10px;
}

.tp-bubble__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 999px;
  background: var(--tm-surface-hover, rgba(22, 104, 227, 0.1));
  color: var(--tm-ink, var(--dark));
  cursor: pointer;
  transition: background 0.15s ease;
}

.tp-bubble__btn:hover {
  background: rgba(22, 104, 227, 0.16);
}

.tp-bubble__btn--accent {
  background: var(--tm-accent, var(--blue));
  color: #fff;
}

.tp-bubble__btn--accent:hover {
  background: var(--tm-accent-bright, var(--blue_plus));
}

.tp-bubble-enter-active,
.tp-bubble-leave-active {
  transition: opacity 0.2s ease, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.tp-bubble-enter-from,
.tp-bubble-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.97);
}
</style>
